import { render } from "./DocumentFieldUpToDate.vue?vue&type=template&id=8230733a"
import script from "./DocumentFieldUpToDate.vue?vue&type=script&lang=js"
export * from "./DocumentFieldUpToDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__